var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(Object.assign({}, _vm.toolTipOptions,
    {content: _vm.tooltipContent})),expression:"{\n    ...toolTipOptions,\n    content: tooltipContent,\n  }"}],class:[
    'merge-tag',
    (_vm.mergeTagType + "-tag"),
    {
      'is-selected': _vm.selected,
      'value-empty': _vm.isMergeValueEmpty,
      'placeholder-state': _vm.mergeValue() === _vm.mergeTagPlaceholder,
    } ],attrs:{"mergeKey":_vm.mergeKeyAttribute,"category":_vm.categoryAttribute,"customName":_vm.customName,"tagId":_vm.tagId,"data-external":("editor-merge-tag-" + _vm.mergeTagType + "-" + _vm.mergeLabel + "-id-" + _vm.tagId)},on:{"dblclick":_vm.openMenu,"click":_vm.selectMergeTag}},[_vm._v(_vm._s(_vm.mergeValue()))])}
var staticRenderFns = []

export { render, staticRenderFns }